const pagesAuthInvitationEn = {
  pageTitle: "Create account",
  pageSubtitle: "Already have an account?",
  pageSubtitleLink: "Sign in",
  firstOrGivenName: "First or given name",
  lastOrFamilyName: "Last or family name",
  middleName: "Middle name",
  email: "Email",
  password: "Create Password",
  passwordPlaceholder:
    "10 letters long with both letters and numbers and special characters (e.g. ^$*.[]{}()?\"!@#%&/\\,><':;|_~`=+-)",
  passwordErrorMessage:
    "Password must be 10 letters long with both letters and numbers and special characters (e.g. ^$*.[]{}()?\"!@#%&/\\,><':;|_~`=+-)",
  showPassword: "Show password",
  agree:
    "Checking here, You have read and agree to our <termsOfUseLink>Terms of Service</termsOfUseLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.",
  submitButton: "Create account",
  acceptInvitationSuccessfulMessage: "🎉 Successfully created account!",
};

export default pagesAuthInvitationEn;
